import PropTypes from 'prop-types';
// Children components
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import Question from './Question';

const Container = styled.div`
  ${tw`px-def`};
`;

const TopQuestion = ({ topQuestions }) => (
  <Container>
    {topQuestions.map((question) => (
      <Question key={question.name} question={question} />
    ))}
  </Container>
);

TopQuestion.propTypes = {
  topQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
};

export default TopQuestion;
